import { APIRoute } from '@/modules/utils'
import { PendingAcquisitionAnimal } from '@/dataV3/Animal/PendingAcquisitionAnimal'
import { AnimalOptions } from '@/dataV3/Animal/AnimalOptions'
import { AnimalSpecies } from '@/dataV3/Animal/AnimalSpecies'

export interface Body {
  fakeAnimal?: boolean
  speciesSlug: AnimalSpecies
  displayName: string
  breedSlug: string
  birthDate: string
  sizeSlug: string
  gender: string
  mainPicture: string | null
  animalOptions: Omit<AnimalOptions, '@id' | '@type'>
  description: string
  animalPictures: string[]
}

export type Response = PendingAcquisitionAnimal

export const Route: APIRoute = {
  method: 'POST',
  path: '/acquisition/members/petowners/animals',
}
